import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24Uploadphoto = /*#__PURE__*/React.memo(function (props) {
  var theme = useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M0 0h24v24H0z"
      }), /*#__PURE__*/jsx("circle", {
        cx: 12,
        cy: 12,
        r: 11,
        fill: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.colorV2.colorSet.grey800,
        fillOpacity: 0.5
      }), /*#__PURE__*/jsxs("g", {
        stroke: props.iconColor ? props.iconColor : theme === null || theme === void 0 ? void 0 : theme.themeMode.lightPalette.colorSet.white1000,
        strokeWidth: 0.867,
        transform: "translate(5.5 7)",
        children: [/*#__PURE__*/jsx("path", {
          d: "M12.567 8.86a1.104 1.104 0 0 1-1.108 1.107H1.541A1.104 1.104 0 0 1 .433 8.859V3.11a1.105 1.105 0 0 1 .874-1.082l2.51-.544c.34-.594 1.037-1.05 1.71-1.05h2.198c.684 0 1.393.468 1.725 1.078l2.252.507a1.105 1.105 0 0 1 .865 1.08z"
        }), /*#__PURE__*/jsx("circle", {
          cx: 6.5,
          cy: 5.633,
          r: 2.167
        })]
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24Uploadphoto$1 = Svg24Uploadphoto;

export { Svg24Uploadphoto$1 as default };
